<style>
.date-time-options {
  color: #000;
}

.date-time-options p {
  display: block;
  font-size: 12px;
  color: #324c62;
  font-family: "Montserrat", sans-serif !important;
  padding: 7px 10px 7px 35px;
  text-align: left;
  word-break: break-word;
  -webkit-transition: all 0.1s ease;
  transition: all 0.1s ease;
  border-radius: 4px;
  text-decoration: none;
  position: relative;
  width: auto;
  margin-bottom: 0;
  cursor: pointer;
}

.date-time-options p:hover {
  text-decoration: none;
  color: #ffffff;
  background: #f4a93f;
  width: auto;
}

.custom-datetime-container {
  width: 252px;
  margin-top: 5px;
  margin: 8px auto;
}

.custom-datetime-select-filter {
  background: none;
  padding: 3px 4px;
  width: 68px;
  float: left;
}

.custom-datetime-input-filter {
  padding: 2px;
  padding-left: 8px;
  width: 61px;
  float: left;
  margin-left: 2px;
}

.custom-datetime-span-filter {
  display: block;
  width: 60px;
  float: left;
  padding: 3px 6px;
  border: 1px solid #a9a9a9;
  font-size: 12px !important;
  margin-left: -1px;
  text-align: center;
}

.custom-datetime-btn-filter {
  background: #624dd6;
  color: #fff;
  border: none;
  padding: 4px 10px;
  font-weight: bold;
  margin-left: 5px;
}
</style>
<template>
  <div class="accordion" id="accordionAutomation">

    <div class="card" v-if="accrodionState == 1">
      <div class="card-header automation-card-header" id="headingOne">
        <p class="mb-0 automation-accordion-p">
          <button class="btn btn-link automation-accordion-btn" type="button" data-toggle="collapse"
                  data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
            {{ table }}
          </button>
        </p>
      </div>
      <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordionAutomation">
        <div class="card-body">
          <div id="filterSearch" class="workflow-row-details">
            <ul>
              <li v-for="field in fields"><a v-on:click.stop.prevent="moreCondition($event,field,table)"
                                             href="javascript:void(0)">{{ field.label }}</a></li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div class="card" v-if="accrodionState == 1 && checkWhenShould()">
      <div class="card-header automation-card-header" id="headingTwo">
        <p class="mb-0 automation-accordion-p">
          <button class="btn btn-link automation-accordion-btn" type="button" data-toggle="collapse"
                  data-target="#collapseTwo" aria-expanded="true" aria-controls="collapseTwo">
            {{ table }}Record.Old Values
          </button>
        </p>
      </div>
      <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo" data-parent="#accordionAutomation">
        <div class="card-body">
          <div id="filterSearch" class="workflow-row-details">
            <ul>
              <li v-for="field in oldValues()"><a v-on:click.stop.prevent="moreCondition($event,field,table)"
                                                  href="javascript:void(0)">{{ field.label }}</a></li>
            </ul>
          </div>
        </div>
      </div>
    </div>


    <div v-else-if="accrodionState == 2">
      <div class="date-time-options" v-if="selectedDateType == 'Day'">
        <p v-bind:class="CustomCheckDateCondition('Previous 3 days')" @click="SelectDateCondition('Previous 3 days')">
          Previous 3 days</p>
        <p v-bind:class="CustomCheckDateCondition('Yesterday')" @click="SelectDateCondition('Yesterday')">Yesterday</p>
        <p v-bind:class="CustomCheckDateCondition('Today')" @click="SelectDateCondition('Today')">Today</p>
        <p v-bind:class="CustomCheckDateCondition('Today (ignore year)')"
           @click="SelectDateCondition('Today (ignore year)')">Today (ignore year)</p>
        <p v-bind:class="CustomCheckDateCondition('Today (same day of any month)')"
           @click="SelectDateCondition('Today (same day of any month)')">Today (same day of any month)</p>
        <p v-bind:class="CustomCheckDateCondition('Next 3 days')" @click="SelectDateCondition('Next 3 days')">Next 3
          days</p>
        <!-- <p v-bind:class="CustomCheckDateCondition('Custom period')" @click="SelectDateCondition('Custom period')">Custom period</p> -->
      </div>

      <div class="date-time-options"
           v-if="selectedDateType == 'Year' || selectedDateType == 'Quater' || selectedDateType == 'Month' || selectedDateType == 'Week'">
        <p v-bind:class="CustomCheckDateCondition('Previous 3 ' + selectedDateType)"
           @click="SelectDateCondition('Previous 3 '+selectedDateType)">Previous 3 {{ selectedDateType }}</p>
        <p v-bind:class="CustomCheckDateCondition('Previous ' + selectedDateType)"
           @click="SelectDateCondition('Previous '+selectedDateType)">Previous {{ selectedDateType }}</p>
        <p v-bind:class="CustomCheckDateCondition('This ' + selectedDateType)"
           @click="SelectDateCondition('This '+selectedDateType)">This {{ selectedDateType }}</p>
        <p v-bind:class="CustomCheckDateCondition('Next ' + selectedDateType)"
           @click="SelectDateCondition('Next '+selectedDateType)">Next {{ selectedDateType }}</p>
        <p v-bind:class="CustomCheckDateCondition('Next 3 ' + selectedDateType)"
           @click="SelectDateCondition('Next 3 '+selectedDateType)">Next 3 {{ selectedDateType }}</p>
        <p v-bind:class="CustomCheckDateCondition('Custom period')" @click="SelectDateCondition('Custom period')">Custom
          period</p>
      </div>

      <div class="date-time-options" v-if="selectedDateType == 'Hour' || selectedDateType == 'Day'">
        <p v-bind:class="CustomCheckDateCondition('Custom period')" @click="SelectDateCondition('Custom period')">Custom
          period</p>
      </div>

      <div class="custom-datetime-container" v-if="selectedDateCondition == 'Custom period'">
        <select v-model="customPeriodType" class="custom-datetime-select-filter">
          <option value="Previous">Previous</option>
          <option value="Next">Next</option>
          <option value="Before">Before</option>
          <option value="After">After</option>
        </select>
        <input v-model="customPeriod" class="custom-datetime-input-filter" type="number">

        <span v-if="selectedDateType == 'Day'" class="custom-datetime-span-filter">Day</span>
        <span v-if="selectedDateType != 'Day'" class="custom-datetime-span-filter">{{ selectedDateType }}</span>

        <button @click="SelectDateCondition('Custom period', true)" class="custom-datetime-btn-filter" type="button">
          OK
        </button>
      </div>

      <input type="text" class="form-control custom-input-value"
             v-model="input"
             v-on:blur="getInput($event)"
             :placeholder="lang.enter+' '+lang.value.toLowerCase()"
             name="custom_text"
             v-if="selectedDateType == null"
      >
      <a href="javascript:void(0)"
         v-on:click.stop.prevent="backToprevious(3)"
         class="custom-input-prev">
        {{ lang.back_to_variables }}
      </a>
    </div>

    <div class="card" v-for="fieldValues,index in tableWithValues" v-else-if="accrodionState == 3">
      <div class="card-header automation-card-header" :id="'heading'+index.replace(' ','_')">
        <p class="mb-0 automation-accordion-p">
          <button class="btn btn-link automation-accordion-btn" type="button" data-toggle="collapse"
                  :data-target="'#accordion-1'+index.replace(' ','_')" aria-expanded="true" aria-controls="collapseOne">
            {{ translation(index) }}
          </button>
        </p>
      </div>
      <div :id="'accordion-1'+index.replace(' ','_')" class="collapse show"
           :aria-labelledby="'heading'+index.replace(' ','_')" data-parent="#accordionAutomation">
        <div class="card-body">
          <div id="filterSearch" class="workflow-row-details">
            <ul>
              <li v-for="(fieldName,fieldValue) in fieldValues" v-if="fieldName != null">
                <a v-on:click.stop.prevent="moreCondition($event,'selection',table,{fieldValue : fieldValue, fieldName : fieldName})"
                   v-bind:class="[toggleClass(fieldValue,fieldName) || CustomCheck(fieldName)]"
                   href="javascript:void(0)">{{ translationDropDownValue(fieldName, index) }}</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>
<script>
export default {
  props: [
    'accrodionState',
    'fields',
    'tableWithValues',
    'table', // selected table name
    'tables', // all existing table in db
    'level', // advanced condition level
    'savedInput',
    'whenQueryEdit', // when query eadit
    'tableField',
    'lang',
    'whenshould',
  ],
  data() {
    return {
      selectionObj: new Object(),
      lastselectedField: null,
      input: null,
      checked: 'addCheck',
      selectedDateType: null,
      selectedDateCondition: null,
      customPeriodType: null,
      customPeriod: null
    }
  },
  mounted() {

    // create a array of all tables value will push in this array
    this.tables.filter(this.tableName);


    // set previous selected value in array

    if (this.whenQueryEdit) {
      for (var obj in this.selectionObj) {
        if (obj == this.table) {
          this.selectionObj[this.table] = this.whenQueryEdit.value;
        }
      }
    }

    if (this.whenQueryEdit) {
      if (this.whenQueryEdit.tableField != this.tableField) {
        this.selectionObj[this.table] = new Array();
      }
    }

    if (this.whenQueryEdit) {
      if (this.whenQueryEdit.check_not_empty == 1) {
        this.selectionObj[this.table] = new Array();
      }
    }

    this.$emit('ResetConditionBtnOccurenceArray');
  },
  created() {
    if (this.whenQueryEdit == null) {
      this.customPeriodType = null;
      this.customPeriod = null;
      this.selectedDateCondition = null;
    } else {
      if (this.savedInput) {
        // check for date and date time
        let _custom_value = this.savedInput.split('.');

        if (
            _custom_value[0] == 'Day' ||
            _custom_value[0] == 'Year' ||
            _custom_value[0] == 'Quater' ||
            _custom_value[0] == 'Month' ||
            _custom_value[0] == 'Week' ||
            _custom_value[0] == 'Hour'
        ) {
          this.selectedDateType = _custom_value[0];

          if (
              (_custom_value[1] != 'Previous 3 days' &&
                  _custom_value[1] != 'Yesterday' &&
                  _custom_value[1] != 'Today' &&
                  _custom_value[1] != 'Today (ignore year)' &&
                  _custom_value[1] != 'Today (same day of any month)' &&
                  _custom_value[1] != 'Next 3 days' &&
                  _custom_value[1] != 'Previous 3 ' + this.selectedDateType &&
                  _custom_value[1] != 'Previous ' + this.selectedDateType &&
                  _custom_value[1] != 'This ' + this.selectedDateType &&
                  _custom_value[1] != 'Next ' + this.selectedDateType &&
                  _custom_value[1] != 'Next 3 ' + this.selectedDateType) ||
              _custom_value[1] == 'Next 3 Day' ||
              _custom_value[1] == 'Previous 3 Day'
          ) {
            this.selectedDateCondition = "Custom period";

            let _custom_value_inputs = _custom_value[1].split(' ');
            this.customPeriodType = _custom_value_inputs[0];
            this.customPeriod = _custom_value_inputs[1];
          } else {
            this.selectedDateCondition = _custom_value[1];
          }

        } else {
          this.input = this.savedInput;
        }
      }
    }

    this.ResetConditionBtnOccurenceArray();
  },
  methods: {
    CustomCheck(value) {
      if (this.selectedDateType == value) {
        return this.checked;
      }
    },
    CustomCheckDateCondition(value) {
      if (this.selectedDateCondition == value) {
        return this.checked;
      }
    },
    SelectDateCondition(condition, force = false) {
      this.selectedDateCondition = condition;
      let _selectedDateCondition = this.selectedDateCondition;

      if (_selectedDateCondition == 'Custom period' || force) {
        let _type = this.selectedDateType;
        if (this.selectedDateType == 'Day') {
          _type = 'Day'
        }

        _selectedDateCondition = this.customPeriodType + " " + this.customPeriod + " " + _type;
      }

      let event = {
        target: {
          value: this.selectedDateType + '.' + _selectedDateCondition
        }
      };

      this.$emit('getInput', event);

      this.$emit('ResetConditionBtnOccurenceArray');
    },
    ResetConditionBtnOccurenceArray() {
      this.$emit('ResetConditionBtnOccurenceArray');
    },
    translation(value) {
      var string = value.toLowerCase();
      string = string.replace(/ /g, '_');
      var translate = this.lang[string];

      return translate != undefined ? translate : value;
    },
    translationDropDownValue(value, index) {

      if (index == 'Custom' || index == 'System') {
        var string = value.toLowerCase();
        string = string.replace(/ /g, '_');
        var translate = this.lang[string];
      }

      return translate != undefined ? translate : value;
    },
    // set on previous selected value right sign class
    toggleClass(fieldValue, fieldName) {
      if (this.whenQueryEdit) {
        var index = this.whenQueryEdit['value'].findIndex(x => x.fieldValue == fieldValue
            && x.fieldName == fieldName);
        if (index != -1) {
          if (fieldValue != 'Having Value') {
            return this.checked;
          }
        }
      }

      this.$emit('ResetConditionBtnOccurenceArray');
    },
    moreCondition(event, field, whichTable, value = null) {
      this.selectedDateType = null;

      if (!value) {
        this.$emit('listenerChild', field, this.selectionObj, this.level);
      } else {

        if (
            value.fieldName != 'Enter Input Value' &&
            value.fieldName != 'Day' &&
            value.fieldName != 'Year' &&
            value.fieldName != 'Quater' &&
            value.fieldName != 'Month' &&
            value.fieldName != 'Week' &&
            value.fieldName != 'Hour'
        ) {
          if (value.fieldName == 'Having Value') {
            // when click or selected having value
            this.selectionObj[whichTable].push(value);
          } else {
            for (let value in this.selectionObj[whichTable]) {
              if (this.selectionObj[whichTable][value] == 'Having Value') {
                this.selectionObj[whichTable] = new Array();
              }
            }

            event.target.classList.toggle('addCheck');
            var index = this.selectionObj[whichTable].findIndex(x => x.fieldValue == value.fieldValue
                && x.fieldName == value.fieldName);

            if (index != -1) {
              this.selectionObj[whichTable].splice(index, 1);
            } else {
              this.selectionObj[whichTable].push({
                fieldName: value.fieldName,
                fieldValue: value.fieldValue
              });
            }
          }
        } else {
          if (
              value.fieldName == 'Day' ||
              value.fieldName == 'Year' ||
              value.fieldName == 'Quater' ||
              value.fieldName == 'Month' ||
              value.fieldName == 'Week' ||
              value.fieldName == 'Hour'
          ) {
            this.selectedDateType = value.fieldName;
          }

          this.$emit('listenerChild', field);
          // not selected any value and having value also. Custom Input
        }

        this.$emit('listenerChild', field, this.selectionObj, this.level);
      }

      this.$emit('ResetConditionBtnOccurenceArray');
    },
    tableName(item) {
      this.selectionObj[item.label] = [];
    },
    backToprevious(sectionId) {
      this.$emit('backToprevious', sectionId);
      this.$emit('ResetConditionBtnOccurenceArray');
    },
    getInput(event) {
      this.input = event.target.value;
      this.$emit('getInput', event);

      this.$emit('ResetConditionBtnOccurenceArray');
    },
    oldValues() {

      let table_fields = JSON.parse(JSON.stringify(this.fields));

      for (let x in table_fields) {
        table_fields[x]['record'] = 'old';
      }
      return table_fields;
    },
    checkWhenShould() {
      if (this.whenshould != 1 && this.whenshould != 2) {
        return true;
      }
    }
  }
}
</script>